export default __webpack_public_path__ + "5c626e3c5f8d56c618e9c42b6b4d60b9.woff";